// extracted by mini-css-extract-plugin
export default {"dropzone":"Ys3Ou"};